module.exports = __webpack_public_path__ + "static/media/Apixel.0aa4c6ed.png";